import styled from '@emotion/styled';
import BEText from '@molecules/Text';
import ScreenSize from '../../../constants/screen-sizes';

export const StyledColumnWrapper = styled.div`
  width: calc(30% - 8px);

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    width: calc(50% - 8px);
  }
`;

export const StyledSection = styled(BEText)`
  margin-top: 8px;
`;

export const StyledSmallInput = styled.div`
  width: 170px;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    width: 100%;
  }
`;
